import { IntersectedStyleTimelineData } from 'src/hooks/style-timeline/queries/useStyleTimelineLevelQuery';

export const StyleTimelineRowUpdatedEvent = 'style-timeline-row-updated';

export interface StyleTimelineRowUpdateEventPayload {
    rows: IntersectedStyleTimelineData[];
}
